import { put, call, takeLatest, select, delay } from 'redux-saga/effects';
import axios from 'axios';
import config from '../config';
import Cookies from 'js-cookie';

//Action
import { loadingSet } from '../action/uiAction';

function* myPostListGet(action) {
  yield put(loadingSet(true));
  const {res, err} = yield call(function (payload) {
    const params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('page', payload.page);
    return axios.post(config.apiUri + "member/myPostListApi.php", params, {
      timeout: 10000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  if (res) {
    if (res.data.bool === true) {
      yield put({
        type: "MY_POST_LIST_SET",
        payload: {
          list: res.data.list,
          page: action.payload.page,
          isListNext: res.data.isListNext,
          count: res.data.count,
        	countOpen: res.data.countOpen,
        },
      });
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}


function* myPostItemGet(action) {
  yield put(loadingSet(true));
  const {res, err} = yield call(function (payload) {
    const params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('postId', payload.postId);
    return axios.post(config.apiUri + "member/myPostItemApi.php", params, {
      timeout: 10000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  if (res) {
    if (res.data.bool === true) {
      action.callback(res.data);
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}

function* myPostDateCheck(action) {
  const {res} = yield call(function (payload) {
    const params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('postDate', payload.date);
    params.append('postId', payload.postId);
    return axios.post(config.apiUri + "member/myPostDateCheckApi.php", params, {
      timeout: 10000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  if (res) {
      action.callback(res.data);
  }
}


function* myPostSave(action) {
  const state = yield select();
  yield put(loadingSet(true));
  const {res, err} = yield call(function (payload) {
    const params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('type', 'save');
    params.append('postId', payload.postId);
    params.append('postDate', payload.postDate);
    params.append('postListOpen', payload.postListOpen);
    params.append('postGoodCountNondisplay', payload.postGoodCountNondisplay);
    params.append('postComment', payload.postComment);
    params.append('imageBase64', payload.imageBase64);
    params.append('check', payload.check);
    return axios.post(config.apiUri + "member/myPostEditApi.php", params, {
      timeout: 10000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  if (res) {
    if (res.data.bool === true) {
      yield delay(500);
      yield put({
        type: 'MY_POST_LIST_GET',
    		payload: {
    			page: state.my.post.page,
    		},
      });
      yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'success', duration: 5000, comment: (action.payload.check ? '投稿を申請しました': '投稿を保存しました')} });
      action.callback(res.data.postId);
    }
    else {
      yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: res.data.comment} });
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}


function* myPostPhotoDel(action) {
  yield put(loadingSet(true));
  const {res, err} = yield call(function (payload) {
    const params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('type', 'photoDel');
    params.append('postId', payload.postId);
    params.append('postPhotoId', payload.postPhotoId);
    return axios.post(config.apiUri + "member/myPostEditApi.php", params, {
      timeout: 10000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  if (res) {
    if (res.data.bool === true) {
      yield delay(500);
      yield put({type: 'MY_POST_LIST_INIT'});
      action.callback(res.data.postId);
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}

function* myPostDel(action) {
  const state = yield select();
  yield put(loadingSet(true));
  const {res, err} = yield call(function (payload) {
    const params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('type', 'del');
    params.append('postId', payload.postId);
    return axios.post(config.apiUri + "member/myPostDelApi.php", params, {
      timeout: 10000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  if (res) {
    if (res.data.bool === true) {
      yield delay(500);
      yield put({
        type: 'MY_POST_LIST_GET',
    		payload: {
    			page: state.my.post.page,
    		},
      });
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}


const saga = [
  takeLatest('MY_POST_LIST_GET', myPostListGet),
  takeLatest('MY_POST_ITEM_GET', myPostItemGet),
  takeLatest('MY_POST_DATE_CHECK', myPostDateCheck),
  takeLatest('MY_POST_SAVE', myPostSave),
  takeLatest('MY_POST_PHOTO_DEL', myPostPhotoDel),
  takeLatest('MY_POST_DEL', myPostDel),

];

export default saga;
